import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  color: "字体颜色",
  bgColor: "背景颜色",
  bgColorIsThemeColor: "背景颜色为主题色",
  opacity: "透明度",
  borderTypeFlag: "圆角类型", // 1:单独设置  2:全部设置
  borderRadius: "圆角",
  borderTopLeftRadius: "边框左上角圆角",
  borderTopRightRadius: "边框右上角圆角",
  borderBottomLeftRadius: "边框左下角圆角",
  borderBottomRightRadius: "边框右下角圆角",
  borderStyle: "边框类型", // solid dashed dotted
  borderColor: "边框颜色",
  borderWidth: "边框宽度",
  borderIsThemeColor: "边框颜色为主题色",
  boxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  paddingTypeFlag: "边距类型",
  padding: "内边距",
  paddingTop: "上内边距",
  paddingRight: "右内边距",
  paddingLeft: "左内边距",
  paddingBottom: "下内边距",

  moreFilter: "是否多级筛选",
  groupMargin: "组间距",
  contentHasLimit: "内容是否字数限制",
  textLimitLines: "字数限制行数",
  fontFamily: "字体",
  fontSize: "字体大小",
  fontWeight: "字重",
  fontStyle: "字体样式",
  textDecoration: "下划线",
  lineHeight: "行高",
  letterSpacing: "字间距",
  writingMode: "排列方式",
  textAlign: "对齐方式",
  textIsThemeColor: "字体颜色跟随主题色",
  lineMargin: "行间距",
  columnMargin: "列间距",

  defaultBorderTypeFlag: "默认圆角类型", // 1:单独设置  2:全部设置
  defaultBorderRadius: "默认圆角",
  defaultBorderTopLeftRadius: "默认边框左上角圆角",
  defaultBorderTopRightRadius: "默认边框右上角圆角",
  defaultBorderBottomLeftRadius: "默认边框左下角圆角",
  defaultBorderBottomRightRadius: "默认边框右下角圆角",
  defaultBorderWidth: "默认边框宽度",
  defaultBorderStyle: "默认边框类型", // solid dashed dotted
  defaultBorderColor: "默认边框颜色",
  defaultBorderIsThemeColor: "默认边框颜色为主题色",
  defaultPaddingTypeFlag: "默认边距类型",
  defaultPadding: "默认内边距",
  defaultPaddingTop: "默认上内边距",
  defaultPaddingRight: "默认右内边距",
  defaultPaddingLeft: "默认左内边距",
  defaultPaddingBottom: "默认下内边距",
  defaultBackground: "默认背景",
  defaultBgColorIsThemeColor: "默认背景颜色跟随主题色",
  defaultBgColor: "默认背景颜色",
  defaultBoxShadowColor: "默认边框阴影颜色",
  defaultBoxShadowH: "默认阴影x轴的偏移量",
  defaultBoxShadowV: "默认阴影y轴的偏移量",
  defaultBoxShadowBlur: "默认阴影模糊值",
  defaultBoxShadowSpread: "默认阴影扩散值",


  titleFontFamily: "标题字体",
  titleFontSize: "标题字体大小",
  titleFontWeight: "标题字重",
  titleFontStyle: "标题字体样式",
  titleTextDecoration: "标题下划线",
  titleLineHeight: "标题行高",
  titleLetterSpacing: "标题字间距",
  titleWritingMode: "标题排列方式",
  titleTextAlign: "标题对齐方式",
  titleTextIsThemeColor: "标题字体颜色跟随主题色",
  titleColor: "标题颜色",
  titleContentHasLimit: "标题内容是否字数限制",
  titleTextLimitLines: "标题字数限制行数",
  titleWidth: "标题宽度",
  titleBackground: "标题背景",
  titleBgColorIsThemeColor: "标题背景颜色跟随主题色",
  titleBgColor: "标题背景颜色",
  titleBoxShadowColor: "标题边框阴影颜色",
  titleBoxShadowH: "标题阴影x轴的偏移量",
  titleBoxShadowV: "标题阴影y轴的偏移量",
  titleBoxShadowBlur: "标题阴影模糊值",
  titleBoxShadowSpread: "标题阴影扩散值",
  titlePaddingTypeFlag: "标题边距类型",
  titlePadding: "标题内边距",
  titlePaddingTop: "标题上内边距",
  titlePaddingRight: "标题右内边距",
  titlePaddingBottom: "标题左内边距",
  titlePaddingLeft: "标题下内边距",
  titleBorderTypeFlag: "标题圆角类型", // 1:单独设置  2:全部设置
  titleBorderRadius: "标题圆角",
  titleBorderTopLeftRadius: "标题左上角圆角",
  titleBorderTopRightRadius: "标题右上角圆角",
  titleBorderBottomLeftRadius: "标题左下角圆角",
  titleBorderBottomRightRadius: "标题右下角圆角",
  titleBorderWidth: "标题边框宽度",
  titleBorderStyle: "标题边框类型", // solid dashed dotted
  titleBorderColor: "标题边框颜色",
  titleBorderIsThemeColor: "标题边框颜色为主题色",

  hoverFontFamily: "悬浮字体",
  hoverFontSize: "悬浮字体大小",
  hoverFontWeight: "悬浮字体字重",
  hoverTextDecoration: "选中下划线",
  hoverLineHeight: "选中行高",
  hoverLetterSpacing: "选中字间距",
  hoverWritingMode: "选中排列方式",
  hoverTextAlign: "选中对齐方式",
  hoverColorIsThemeColor: "悬浮颜色为主题色",
  hoverColor: "悬浮颜色",
  hoverBorderTypeFlag: "悬浮圆角类型", // 1:单独设置  2:全部设置
  hoverBorderRadius: "悬浮圆角",
  hoverBorderTopLeftRadius: "悬浮边框左上角圆角",
  hoverBorderTopRightRadius: "悬浮边框右上角圆角",
  hoverBorderBottomRightRadius: "悬浮边框左下角圆角",
  hoverBorderBottomLeftRadius: "悬浮边框右下角圆角",
  hoverBgColorIsThemeColor: "悬浮背景颜色跟随主题色",
  hoverBgColor: "悬浮背景颜色",
  hoverBorderStyle: "悬浮边框类型", // solid dashed dotted
  hoverBorderColor: "悬浮边框颜色",
  hoverBorderWidth: "悬浮边框宽度",
  hoverBorderIsThemeColor: "悬浮边框颜色为主题色",
  hoverBackground: "悬浮背景",
  hoverBoxShadowColor: "悬浮边框阴影颜色",
  hoverBoxShadowH: "悬浮阴影x轴的偏移量",
  hoverBoxShadowV: "悬浮阴影y轴的偏移量",
  hoverBoxShadowBlur: "悬浮阴影模糊值",
  hoverBoxShadowSpread: "悬浮阴影扩散值",

  activeFontFamily: "选中字体",
  activeFontSize: "选中字体大小",
  activeFontWeight: "选中字体字重",
  activeTextDecoration: "选中下划线",
  activeLineHeight: "选中行高",
  activeLetterSpacing: "选中字间距",
  activeWritingMode: "选中排列方式",
  activeTextAlign: "选中对齐方式",
  activeTextIsThemeColor: "选中字体颜色跟随主题色",
  activeColor: "选中颜色",

  activeBorderTypeFlag: "选中圆角类型", // 1:单独设置  2:全部设置
  activeBorderRadius: "选中圆角",
  activeBorderTopLeftRadius: "选中边框左上角圆角",
  activeBorderTopRightRadius: "选中边框右上角圆角",
  activeBorderBottomRightRadius: "选中边框左下角圆角",
  activeBorderBottomLeftRadius: "选中边框右下角圆角",
  activeBgColorIsThemeColor: "选中背景颜色跟随主题色",
  activeBgColor: "选中背景颜色",
  activeBorderWidth: "选中边框宽度",
  activeBorderStyle: "选中边框类型", // solid dashed dotted
  activeBorderColor: "选中边框颜色",
  activeBorderIsThemeColor: "选中边框颜色为主题色",
  activeBackground: "选中背景",
  activeBoxShadowColor: "选中阴影颜色",
  activeBoxShadowH: "选中阴影x轴的偏移量",
  activeBoxShadowV: "选中阴影y轴的偏移量",
  activeBoxShadowBlur: "选中阴影模糊值",
  activeBoxShadowSpread: "选中阴影扩散值",

  noCacheComponent: "非缓存组件",
  restDataUrl: "外接数据源地址",
  selectOptions: "多级筛选选项",
}
export const getOptDes = toSelectOpt.bind(this, optDes)
